import baseWs from "./baseWs";
import _ from "lodash";
//import axios from 'axios';

export function fetchDisplayValue(
  lovTable,
  lovKey,
  lovValue,
  constraints,
  value
) {
  return baseWs
    .post("/api/services/app/listOfValues/FetchDisplayValue", {
      lovTable: lovTable,
      lovKey: lovKey,
      lovValue: lovValue,
      value: value,
      constraints: constraints,
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (!_.isEmpty(err.response)) {
        console.log("Error");
      }
      console.log("Error getting lov display value: " + err);
      throw err;
    });
}

export function fetchModelValue(
  lovTable,
  lovKey,
  lovValue,
  constraints,
  value
) {
  return baseWs
    .post("/api/services/app/listOfValues/FetchModelValue", {
      lovTable: lovTable,
      lovKey: lovKey,
      lovValue: lovValue,
      value: value,
      constraints: constraints,
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (!_.isEmpty(err.response)) {
        console.log("Error");
      }
      console.log("Error getting lov display value: " + err);
      throw err;
    });
}

export function populateListOfValues(lovTable, searchSize, constraints) {
  return baseWs
    .post("/api/services/app/listOfValues/PopulateListOfValues", {
      lovTable: lovTable,
      queryOptions: constraints,
      searchSize: searchSize,
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (!_.isEmpty(err.response)) {
        console.log("Error");
      }
      console.log("Error getting lov data: " + err);
      throw err;
    });
}

export function fetchAutoCompleteListOfValues(
  lovTable,
  lovKey,
  lovValue,
  constraints,
  value
) {
  return baseWs
    .post("/api/services/app/listOfValues/FetchModelAutoComplete", {
      lovTable: lovTable,
      lovKey: lovKey,
      lovValue: lovValue,
      value: value,
      constraints: constraints,
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (!_.isEmpty(err.response)) {
        console.log("Error");
      }
      console.log("Error getting lov auto complete data: " + err);
      throw err;
    });
}
